export const BUNDLE_FILTER_KEY = "MY";
export const OWN_BUNDLE_ID = "4e05a280-3aac-49bf-8f61-6abe639a9f00";
